module.exports = __webpack_public_path__ + "img/Hunter-draenei-m-70.61256e9d.gif";